<template>
  <el-row class="cs-contentContainer cs-suppStudentInfo-container">
    <el-col :span="4" class="cs-contentContainer-registerLeft">
      <div>&nbsp;</div>
    </el-col>
    <el-col :span="16" class="cs-fullHeight cs-suppStudentInfo-middleContainer">
   
        <el-form :model="supplementForm" class="cs-suppStudentInfo-form" :rules="rules" label-width="100px" ref="supplementForm">
      
            <el-row class="margin-bottom-2px backgroud-white cs-register-title">
              <el-col :span="24" class="su-title">
                <span>速成学员补录信息</span>
              </el-col>
            </el-row>
            <el-row class="backgroud-white cs-register-main" style="height: calc(100% - 268px);">
              <el-col :span="6">
                &nbsp;
              </el-col>
              <el-col :span="12">
                <div class="grid-content">
                  <el-form-item prop="lastName" label="姓">
                    <el-input @change='checkAllInputs' placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="supplementForm.lastName"></el-input>
                  </el-form-item>
                  <el-form-item prop="firstName" label="名">
                    <el-input @change='checkAllInputs' placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="supplementForm.firstName"></el-input>
                  </el-form-item>
                  <el-form-item prop="email" label="邮箱">
                    <el-input @change='checkAllInputs' placeholder="请输入邮箱" v-model="supplementForm.email"></el-input>
                  </el-form-item>
                  <el-form-item class="su-left-align cs-register-btn-container">
                    <div class="errorMessageContainer">
                      <el-alert class="cs-register-alert" :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                    </div>
                    <div class="cs-register-btn">
                      <el-button :disabled="supplementBtnDisable" v-bind:type="supplementBtnClass" @click="supplementInfo">立即补录</el-button>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item class="su-left-align cs-register-wechat-container" v-if="user_student_hasWechat">
                    <el-button type="primary" @click="registerWechat">绑定微信</el-button>
                  </el-form-item> -->
                </div>
              </el-col>
              <el-col :span="6">
                &nbsp;
              </el-col>
            </el-row>
            <el-row class="cs-register-mobile backgroud-white">
              <el-col>
                 <el-button :disabled="supplementBtnDisable" v-bind:type="supplementBtnClass" @click="supplementInfo">立即补录</el-button>
                  <div class="errorMessageContainer">
                    <el-alert class="cs-register-alert" :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                  </div>
              </el-col>
            </el-row>
            <el-row class="backgroud-gray su-left-align cs-register-foot">
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <strong> &nbsp;</strong>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control cs-bold">
                  <small>速成学员补录信息</small>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <small>凡是在速成教育报名的学员，必须填写驾照，护照，学生证上合法的Legal Name和邮箱。</small>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <strong> &nbsp;</strong>
                </div>
              </el-col>
            </el-row>
            <el-row class="hidden-xs-only cs-register-bottom backgroud-black text-center">
              <el-col>
                <footer>
                  <small>Powered by Speed Up Education Inc.</small>
                </footer>
              </el-col>
            </el-row>
        </el-form>
    </el-col>
    <el-col :span="4" class="cs-contentContainer-registerRight">
      <div>&nbsp;</div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
body .cs-wrapper .cs-content .cs-suppStudentInfo-container{
  height: 100%;
  .cs-suppStudentInfo-middleContainer{
    height: 100%;
    .cs-suppStudentInfo-form{
      height: 100%;
    }
  }
}

.supplementForm {
  text-align: left;
}
.grid-content {
  margin-top: 26px;
}
.su-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 35px;
  text-align: center;
}
.el-form-item {
  margin-bottom: 10px;

  &.is-required {
    label {
      &:before {
        content: "";
      }
    }
  }
}
.cs-register-foot {
  padding: 5px 0 5px 0;
  .el-form-control {
    margin-bottom: 0px;
  }
}
.cs-register-wechat-container{
  text-align: right;
}
.cs-register-btn-container {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;

  .cs-register-btn {
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}

.errorMessageContainer {
  display: inline-block;
  vertical-align: middle;
  min-height: 56px;

  .cs-register-alert {
    padding: 0 10px;
  }
}

.cs-register-bottom{
  height:60px;
  footer{
    line-height: 60px;
  }
}
</style>

<script>
import { getStudentMemberInfo, supplementStudentInfo } from "@/service/student.service";
import { setStore, getStore } from "@/config/mUtils";


export default {
  data() {
    return {
      user_student_hasWechat: false,
      showError: false,
      errorMessage: "",
      dialogVisible: false,
      supplementBtnClass: "primary",
      supplementBtnDisable: false,
      studentId: 0,
      studentData: {},
      supplementForm: {
        firstName: "",
        lastName: "",
        email: ""
      },
      rules: {
        firstName: [
            {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: "blur"
          }
        ],
        lastName: [
            {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          },
          {
            type: 'email',
            message: "邮箱格式错误",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components:{
 
  },
  async created() {
    this.user_student_hasWechat = getStore("user_student_hasWechat") == "1";
    await this.loadStudentInfoFromServer();
    this.reloadSupplementForm();
  },
  methods: {
    
    async loadStudentInfoFromServer() {
        this.studentId = getStore("user_student_id");
        let result = await getStudentMemberInfo(this.studentId);
        if (!!result && result.success) {
            this.studentData = result.data;
        } else {
            this.studentData = {};
        }
    },
    reloadSupplementForm() {
        if (Object.keys(this.studentData).length > 0) {
            this.supplementForm.firstName = this.studentData.FirstName;
            this.supplementForm.lastName = this.studentData.LastName;
            this.supplementForm.email = this.studentData.Email;
        } else {
            this.supplementForm.firstName = "";
            this.supplementForm.lastName = "";
            this.supplementForm.email = "";
        }
    },
    //发送补录信息
    async supplementInfo() {
        if (!this.$refs["supplementForm"])
            return false;

        let isValid = true;
        this.$refs["supplementForm"].validate(valid => {
            if (valid) {
            } else {
            isValid = false;
            }
        });
        if (!isValid) {
            return false;
        }
        
        this.supplementBtnDisable = true;
        this.showError = false;
        this.errorMessage = "";
        let result = await supplementStudentInfo(
          this.studentId,
          this.supplementForm.firstName,
          this.supplementForm.lastName,
          this.supplementForm.email
        );
        this.supplementBtnDisable = false;
        if (!result)
            return false;
        
        if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
            return false;
        }

        if (!result.data) {
            this.errorMessage = "补录信息保存失败";
            this.showError = true;
            return false;
        }

        setStore("user_student_hasUninputedInfo", 0);
        this.checkRedirect();
    },
    checkRedirect(){
      let user_student_hasUninputedInfo = getStore("user_student_hasUninputedInfo");
      if (user_student_hasUninputedInfo == "0"){
        let user_student_enable = getStore("user_student_enable");
        let user_student_hasStudentCourseNumber = getStore(
            "user_student_hasStudentCourseNumber"
        );

        if (user_student_enable == "0") {
            this.$router.push("/studentLanding");
            return false;
        }
        
        if (user_student_hasStudentCourseNumber == "1") {
            this.$router.push("/studentLanding");
        } else {
            this.$router.push("/studentLanding");
            //this.$router.push("/courseCount");
        }
      }
    },
    checkAllInputs() {
      if (
        !!this.supplementForm.firstName &&
        !!this.supplementForm.lastName &&
        !!this.supplementForm.email
      ) {
        this.supplementBtnClass = "primary";
        this.supplementBtnDisable = false;
      } else {
        this.supplementBtnClass = "info";
        this.supplementBtnDisable = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/supplementStudentInfo.vue